module.exports = __webpack_public_path__ + "img/icon-activity-add.43dd6ad5.svg";